<template>
  <div style="background: #f7f7f7;padding: 10px">
    <div style="background: #fff;margin: -10px -10px 10px -10px;">
      <div class="kanban-title">安骏物流转运看板(Sinalização de transbordo da AnJun Logística)</div>
      <div style="padding: 20px;margin-bottom: 10px;" class="search-kan">
        <el-form size="small">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="大区Região" label-width="90px">
                <el-select
                  v-model="queryForm.regionIdList"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  style="width: 100%"
                  @change="selectRegionChange"
                >
                  <el-option
                    v-for="item in regionList"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item.regionId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="州Estado" label-width="90px">
                <el-select
                  v-model="queryForm.stateList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  style="width: 100%"
                  @change="changeSiteList"
                >
                  <el-option
                    v-for="item in siteList"
                    :key="item.state"
                    :label="item.state"
                    :value="item.state"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="转运中心HUB" label-width="100px">
                <el-select
                  v-model="queryForm.siteIdList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in transferCenterList"
                    :key="item.siteId"
                    :label="item.siteName"
                    :value="item.siteId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div>
                <el-button
                  icon="el-icon-search"
                  size="small"
                  type="primary"
                  @click="searchResources(1)"
                >{{ $t('operationCenter.Procurar') }}
                </el-button>
                <el-button icon="el-icon-refresh-left" size="small" @click="searchResources(2)">
                  {{ $t('operationCenter.reset') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <el-row style="font-size: 15px;margin-bottom: 10px;">
      <el-col :span="19">
        <div style="background: #fff;padding: 15px;border-radius: 5px;margin-right: 10px;">
          <div style="font-weight: bold;margin-bottom: 10px;">小件(Pacote Pequeno)</div>
          <div style="display: flex;margin-bottom: 40px;">
            <div style="width: 260px;margin-top: 30px">
              <div style="display: flex;border-left: 3px solid #1d6a33;padding: 6px 0 6px 10px;align-items: center; background: linear-gradient(to right, #dfefe3, transparent);margin-bottom: 20px;">
                <div style="flex: 1;font-weight: bold;">{{ formatNumber(backlogData.smallBacklog.twentyFourReceiptQuantity, 0) }}</div>
                <div style="width: 160px;font-size: 14px;line-height: 14px">
                  <div><span style="color: #009944;">24</span>小时入库数</div>
                  <div>(entradas em 24 horas)</div>
                </div>
              </div>
              <div style="display: flex;border-left: 3px solid #e3cb05;padding: 6px 0 6px 10px;align-items: center; background: linear-gradient(to right, #f6edc7, transparent);">
                <div style="flex: 1;font-weight: bold;">{{ formatNumber(backlogData.smallBacklog.twentyFourSendQuantity, 0) }}</div>
                <div style="width: 160px;font-size: 14px;line-height: 14px">
                  <div><span style="color: #f5c936;">24</span>小时出库数</div>
                  <div>(saídas em 24 horas)</div>
                </div>
              </div>
            </div>
            <div style="flex: 1;">
              <div id="smallCargo" style="height: 200px;width: 100%;" />
            </div>
          </div>
          <div style="font-weight: bold;margin-bottom: 10px;">大件(Carga grande)</div>
          <div style="display: flex">
            <div style="width: 260px;margin-top: 30px">
              <div style="display: flex;border-left: 3px solid #1d6a33;padding: 6px 0 6px 10px;align-items: center; background: linear-gradient(to right, #dfefe3, transparent);margin-bottom: 20px;">
                <div style="flex: 1;font-weight: bold;">{{ formatNumber(backlogData.largeBacklog.twentyFourReceiptQuantity, 0) }}</div>
                <div style="width: 160px;font-size: 14px;line-height: 14px">
                  <div><span style="color: #009944;">24</span>小时入库数</div>
                  <div>(entradas em 24 horas)</div>
                </div>
              </div>
              <div style="display: flex;border-left: 3px solid #e3cb05;padding: 6px 0 6px 10px;align-items: center; background: linear-gradient(to right, #f6edc7, transparent);">
                <div style="flex: 1;font-weight: bold;">{{ formatNumber(backlogData.largeBacklog.twentyFourSendQuantity, 0) }}</div>
                <div style="width: 160px;font-size: 14px;line-height: 14px">
                  <div><span style="color: #f5c936;">24</span>小时出库数</div>
                  <div>(saídas em 24 horas)</div>
                </div>
              </div>
            </div>
            <div style="flex: 1;">
              <div id="bulkyCargo" style="height: 200px;width: 100%;" />
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="5" style="background: #fff;padding: 15px;border-radius: 5px">
        <div style="font-weight: bold;margin-bottom: 25px;">退件(Devolução)</div>
        <div style="display: flex;align-items: center;margin-bottom: 25px;">
          <img src="@/assets/images/daifahuo(24).png" style="width: 24px;height: 24px;" alt="">
          <div style="flex: 1;line-height: 18px;padding-left: 10px">
            <div style="font-size: 14px"><span style="color: #009944;">24</span>小时退件数(Número de devoluções em 24 horas)</div>
            <div style="font-weight: bold">{{ formatNumber(backlogData.returnBacklog.twentyFourReturnQuantity, 0) }}</div>
          </div>
        </div>
        <div style="display: flex;align-items: center;margin-bottom: 25px;">
          <img src="@/assets/images/daifahuo(48).png" style="width: 24px;height: 24px;" alt="">
          <div style="flex: 1;line-height: 18px;padding-left: 10px">
            <div style="font-size: 14px"><span style="color: #f5c936;">48</span>小时退件数(Número de devoluções em 48 horas)</div>
            <div style="font-weight: bold">{{ formatNumber(backlogData.returnBacklog.fortyEightReturnQuantity, 0) }}</div>
          </div>
        </div>
        <div style="margin-bottom: 25px;">
          <div style="font-size: 14px;margin-bottom: 5px;">24h退件未处理数(Devolução não processada em até 24 horas)</div>
          <el-progress
            :key="backlogData.returnBacklog.progress24"
            :show-text="false"
            :stroke-width="8"
            :percentage="backlogData.returnBacklog.progress24"
            color="#ff4949"
          />
          <div style="font-weight: bold;margin-top: 5px;">{{ formatNumber(backlogData.returnBacklog.twentyFourReturnDetentionQuantity, 0) }}</div>
        </div>
        <div style="margin-bottom: 25px;">
          <div style="font-size: 14px;margin-bottom: 5px;">48h退件未处理数(Devolução não processada em até 48 horas)</div>
          <el-progress
            :key="backlogData.returnBacklog.progress48"
            :show-text="false"
            :stroke-width="8"
            :percentage="backlogData.returnBacklog.progress48"
            color="#ff4949"
          />
          <div style="font-weight: bold;margin-top: 5px;">{{ formatNumber(backlogData.returnBacklog.fortyEightReturnDetentionQuantity, 0) }}</div>
        </div>
        <div>
          <div style="font-size: 14px;margin-bottom: 5px;">48+h退件未处理数(Devolução não processada em até 48+ horas)</div>
          <el-progress
            :show-text="false"
            :stroke-width="8"
            :percentage="progress48add"
            color="#ff4949"
          />
          <div style="font-weight: bold;margin-top: 5px;">{{ formatNumber(backlogData.returnBacklog.fortyEightReturnDetentionOverQuantity, 0) }}</div>
        </div>
      </el-col>
    </el-row>
    <div style="padding: 15px;background: #fff;">
      <div style="font-weight: bold;font-size: 15px">各州发货排行(Ranking de Envio por Estado)</div>
      <div id="ranking" style="height: 200px;width: 100%;" />
    </div>
  </div>
</template>

<script>
import {
  getTransferDelayData,
  getTransferStateDeliveryRanking,
  getTransferWarehouseList
} from '@/api/orderApi';
import { formatNumber } from '@/utils/tools';
import * as echarts from 'echarts';
export default {
  name: 'TransferKanbanBoard',
  data() {
    return {
      queryForm: {
        regionIdList: [],
        stateList: [],
        siteIdList: []
      },
      regionList: [],
      siteList: [],
      transferCenterList: [],
      smallCargoChart: null,
      bulkyCargoChart: null,
      backlogData: {
        smallBacklog: {},
        largeBacklog: {},
        returnBacklog: {}
      },
      stateDeliveryData: [],
      progress48add: 0,
      allAddressOption: [],
      formatNumber
    };
  },
  created() {
    this.getRegionStateSite();
  },
  mounted() {
    this.smallCargoChart = echarts.init(document.getElementById('smallCargo'));
    this.bulkyCargoChart = echarts.init(document.getElementById('bulkyCargo'));
    this.rankingCargoChart = echarts.init(document.getElementById('ranking'));
    this.getChartData();
    // 添加屏幕缩放自适应
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除监听器，防止内存泄漏
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 初始获取所有的大区，州，站点
    getRegionStateSite() {
      const param = {
        regionIdList: [],
        stateList: []
      };
      getTransferWarehouseList(param).then(res => {
        if (res.code === 200) {
          this.allAddressOption = res.data;
          // 过滤掉regionId相同的数据获取大区选项
          const regionOption = new Set();
          this.regionList = this.allAddressOption.filter(item => {
            if (regionOption.has(item.regionId)) {
              return false;
            }
            regionOption.add(item.regionId);
            return true;
          });
          // 过滤掉state相同数据获取州选项
          const stateOption = new Set();
          this.siteList = this.allAddressOption.filter(item => {
            if (stateOption.has(item.state)) {
              return false;
            }
            stateOption.add(item.state);
            return true;
          });
          this.transferCenterList = this.allAddressOption;
        }
      });
    },
    // 州选项变化
    changeSiteList() {
      this.transferCenterList = [];
      this.queryForm.siteIdList = [];
      // 如果 regionIdList 为空，则只根据 stateList 过滤
      if (this.queryForm.regionIdList.length === 0) {
        if (this.queryForm.stateList.length === 0) {
          // 如果两个数组都为空，显示所有数据
          this.transferCenterList = this.allAddressOption; // 需要先保存完整数据
        } else {
          // 只根据 stateList 过滤
          this.transferCenterList = this.allAddressOption.filter(item =>
            this.queryForm.stateList.includes(item.state)
          );
        }
      } else {
        if (this.queryForm.stateList.length === 0) {
          // 只根据 regionIdList 过滤
          this.transferCenterList = this.allAddressOption.filter(item =>
            this.queryForm.regionIdList.includes(item.regionId)
          );
        } else {
          // 同时根据 regionIdList 和 stateList 过滤
          this.transferCenterList = this.allAddressOption.filter(item =>
            this.queryForm.regionIdList.includes(item.regionId) &&
            this.queryForm.stateList.includes(item.state)
          );
        }
      }
    },
    // 选择大区变化
    selectRegionChange() {
      this.queryForm.stateList = [];
      this.siteList = [];
      this.transferCenterList = [];
      this.queryForm.siteIdList = [];
      if (this.queryForm.regionIdList.length === 0) {
        this.transferCenterList = this.allAddressOption;
        // 过滤掉state相同数据获取州选项
        const stateOption = new Set();
        this.siteList = this.allAddressOption.filter(item => {
          if (stateOption.has(item.state)) {
            return false;
          }
          stateOption.add(item.state);
          return true;
        });
      } else {
        // 只根据 regionIdList 过滤
        this.transferCenterList = this.allAddressOption.filter(item =>
          this.queryForm.regionIdList.includes(item.regionId)
        );
        const stateOption = new Set();
        this.siteList = this.transferCenterList.filter(item => {
          if (stateOption.has(item.state)) {
            return false;
          }
          stateOption.add(item.state);
          return true;
        });
      }
    },
    // 搜索
    searchResources(type) {
      if (type === 2) {
        this.queryForm = {
          regionIdList: [],
          stateList: [],
          siteIdList: []
        };
      }
      this.getChartData();
    },
    // 图表自适应
    handleResize() {
      // 调用 ECharts 的 resize 方法实现自适应
      if (this.smallCargoChart) {
        this.smallCargoChart.resize();
      }
      if (this.bulkyCargoChart) {
        this.bulkyCargoChart.resize();
      }
      if (this.rankingCargoChart) {
        this.rankingCargoChart.resize();
      }
    },
    // 获取图表数据
    async getChartData() {
      await getTransferDelayData(this.queryForm).then(res => {
        if (res.code === 200) {
          const nullData = {
            fifteenDaysDetentionQuantity: 0, // 大小件---15天滞留
            fifteenDaysOverDetentionQuantity: 0, // 大小件---超15天滞留
            fortyEightDetentionQuantity: 0, // 大小件---48小时滞留
            fortyEightReturnDetentionOverQuantity: 0, // 退件----超48小时退件滞留
            fortyEightReturnDetentionQuantity: 0, // 退件----48小时退件滞留
            fortyEightReturnQuantity: 0, // 退件----48小时退件数
            orderPackageType: null, // 包裹类型
            regionId: null, // 大区id
            regionName: null, // 大区名称
            sevenDaysDetentionQuantity: 0, // 大小件---7天滞留
            seventyTwoDetentionQuantity: 0, // 大小件---72小时滞留
            siteId: null, // 网点id
            siteName: null, // 网点名称
            state: null, // 州
            twentyFourDetentionQuantity: 0, // 大小件---24小时滞留
            twentyFourReceiptQuantity: 0, // 大小件---24小时入库数
            twentyFourReturnDetentionQuantity: 0, // 退件----24小时退件滞留数
            twentyFourReturnQuantity: 0, // 退件------24小时退件数
            twentyFourSendQuantity: 0 // 大小件-----24小时出库数
          };
          const splitByPackageType = (data) => {
            // 使用reduce方法将数组按orderPackageType分组
            const groupedData = data.reduce((acc, item) => {
              const packageType = item.orderPackageType;
              acc[packageType] = item;
              return acc;
            }, {});
            // 返回拆分后的三个对象
            return {
              smallBacklog: groupedData['小件'] || nullData,
              largeBacklog: groupedData['大件'] || nullData,
              returnBacklog: groupedData['退件'] || nullData
            };
          };
          const dataObj = splitByPackageType(res.data);
          dataObj.returnBacklog.progress24 = (dataObj.returnBacklog.twentyFourReturnDetentionQuantity / dataObj.returnBacklog.twentyFourReturnQuantity) * 100;
          dataObj.returnBacklog.progress48 = (dataObj.returnBacklog.fortyEightReturnDetentionQuantity / dataObj.returnBacklog.fortyEightReturnQuantity) * 100;
          this.backlogData = {
            smallBacklog: {
              lineList: [
                {
                  day: '24小时\n(24horas)',
                  deliveryCount: dataObj.smallBacklog.twentyFourDetentionQuantity || 0
                },
                {
                  day: '48小时\n(48horas)',
                  deliveryCount: dataObj.smallBacklog.fortyEightDetentionQuantity || 0
                },
                {
                  day: '72小时\n(72horas)',
                  deliveryCount: dataObj.smallBacklog.seventyTwoDetentionQuantity || 0
                },
                {
                  day: '7天\n(7 dias)',
                  deliveryCount: dataObj.smallBacklog.sevenDaysDetentionQuantity || 0
                },
                {
                  day: '15天\n(15 dias)',
                  deliveryCount: dataObj.smallBacklog.fifteenDaysDetentionQuantity || 0
                },
                {
                  day: '超15天\n(Mais de 15 dias)',
                  deliveryCount: dataObj.smallBacklog.fifteenDaysOverDetentionQuantity || 0
                }
              ],
              twentyFourReceiptQuantity: dataObj.smallBacklog.twentyFourReceiptQuantity || 0,
              twentyFourSendQuantity: dataObj.smallBacklog.twentyFourSendQuantity || 0
            },
            largeBacklog: {
              lineList: [
                {
                  day: '24小时\n(24horas)',
                  deliveryCount: dataObj.largeBacklog.twentyFourDetentionQuantity || 0
                },
                {
                  day: '48小时\n(48horas)',
                  deliveryCount: dataObj.largeBacklog.fortyEightDetentionQuantity || 0
                },
                {
                  day: '72小时\n(72horas)',
                  deliveryCount: dataObj.largeBacklog.seventyTwoDetentionQuantity || 0
                },
                {
                  day: '7天\n(7 dias)',
                  deliveryCount: dataObj.largeBacklog.sevenDaysDetentionQuantity || 0
                },
                {
                  day: '15天\n(15 dias)',
                  deliveryCount: dataObj.largeBacklog.fifteenDaysDetentionQuantity || 0
                },
                {
                  day: '超15天\n(Mais de 15 dias)',
                  deliveryCount: dataObj.largeBacklog.fifteenDaysOverDetentionQuantity || 0
                }
              ],
              twentyFourReceiptQuantity: dataObj.largeBacklog.twentyFourReceiptQuantity || 0,
              twentyFourSendQuantity: dataObj.largeBacklog.twentyFourSendQuantity || 0
            },
            returnBacklog: dataObj.returnBacklog || nullData
          };
          this.progress48add = 0;
          if (!dataObj.returnBacklog.fortyEightReturnDetentionOverQuantity) {
            this.progress48add = 0;
          } else if (dataObj.returnBacklog.fortyEightReturnDetentionOverQuantity < 5000) {
            this.progress48add = 20;
          } else if (dataObj.returnBacklog.fortyEightReturnDetentionOverQuantity > 5000 < 10000) {
            this.progress48add = 30;
          } else if (dataObj.returnBacklog.fortyEightReturnDetentionOverQuantity > 10000 < 20000) {
            this.progress48add = 40;
          } else if (dataObj.returnBacklog.fortyEightReturnDetentionOverQuantity > 20000) {
            this.progress48add = 60;
          }
        }
      });
      await getTransferStateDeliveryRanking().then(res => {
        if (res.code === 200) {
          this.stateDeliveryData = res.data;
        }
      });
      this.initChart();
    },
    // 初始化图表
    initChart() {
      // 小件滞留
      const smallItemBacklog = {
        name: '小件滞留(Atraso de pequenos pacotes)', // '小件滞留',
        type: 'line',
        label: {
          show: true, // 显示数值
          position: 'top', // 数值显示在折线上方
          fontSize: 13, // 数值字体大小
          distance: 5,
          fontWeight: 'bold',
          formatter: (params) => {
            return formatNumber(params.value, 0);
          }
        },
        itemStyle: {
          color: (params) => {
            // 根据x轴索引设置不同颜色
            const colors = ['#0e792b', '#0e792b', '#0e792b', '#ff494b', '#ff494b', '#ff494b'];
            return colors[params.dataIndex % colors.length];
          }
        },
        lineStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: '#0e792b' }, // 24小时-72小时
            { offset: 0.5, color: '#0e792b' }, // 7天
            { offset: 0.7, color: '#ff494b' }, // 15天
            { offset: 1, color: '#ff494b' } // 超15天
          ])
        },
        data: []
      };
      const smallItemDataArr = [];
      smallItemDataArr.push(smallItemBacklog);
      const smallDays = [];
      this.backlogData.smallBacklog.lineList.map(item => {
        smallDays.push(item.day);
        smallItemBacklog.data.push(item.deliveryCount);
      });
      const smallItemOption = {
        title: {
          text: '小件滞留(Atraso de pequenos pacotes)',
          left: 'left',
          textStyle: {
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '27%',
          left: '5%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false // 隐藏分隔线
          },
          axisLabel: {
            interval: 0, // 强制显示所有刻度
            fontWeight: 'bold',
            color: '#333'
          },
          axisLine: {
            show: false // 隐藏x轴线
          },
          data: smallDays
        },
        yAxis: {
          type: 'value',
          splitLine: { // 设置Y轴的线条的颜色;
            show: false
          },
          axisTick: {
            show: false // 隐藏y轴刻度线
          },
          axisLabel: {
            show: false // 隐藏y轴刻度标签
          }
        },
        series: smallItemDataArr
      };
      smallItemOption && this.smallCargoChart.setOption(smallItemOption, true); // 小件
      // 大件滞留
      const largeItemRetention = {
        name: '大件滞留(Grande carga fica retida)', // '大件滞留',
        type: 'line',
        itemStyle: {
          color: (params) => {
            // 根据x轴索引设置不同颜色
            const colors = ['#0e792b', '#0e792b', '#0e792b', '#ff494b', '#ff494b', '#ff494b'];
            return colors[params.dataIndex % colors.length];
          }
        },
        lineStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: '#0e792b' }, // 24小时-72小时
            { offset: 0.5, color: '#0e792b' }, // 7天
            { offset: 0.7, color: '#ff494b' }, // 15天
            { offset: 1, color: '#ff494b' } // 超15天
          ])
        },
        label: {
          show: true, // 显示数值
          position: 'top', // 数值显示在折线上方
          fontSize: 13, // 数值字体大小
          distance: 5,
          fontWeight: 'bold',
          formatter: (params) => {
            return formatNumber(params.value, 0);
          }
        },
        data: []
      };
      const largeItemDataArr = [];
      largeItemDataArr.push(largeItemRetention);
      const largeDays = [];
      this.backlogData.largeBacklog.lineList.map(item => {
        largeDays.push(item.day);
        largeItemRetention.data.push(item.deliveryCount);
      });
      const largeItemOption = {
        title: {
          text: '大件滞留(Grande carga fica retida)',
          left: 'left',
          textStyle: {
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '27%',
          left: '5%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false // 隐藏分隔线
          },
          axisLabel: {
            interval: 0, // 强制显示所有刻度
            fontWeight: 'bold',
            color: '#333'
          },
          axisLine: {
            show: false // 隐藏x轴线
          },
          data: largeDays
        },
        yAxis: {
          type: 'value',
          splitLine: { // 设置Y轴的线条的颜色;
            show: false
          },
          axisTick: {
            show: false // 隐藏y轴刻度线
          },
          axisLabel: {
            show: false // 隐藏y轴刻度标签
          }
        },
        series: largeItemDataArr
      };
      largeItemOption && this.bulkyCargoChart.setOption(largeItemOption, true);
      // 发货排行
      const stateDeliveryOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            return `${params[0].name}<br/>${params[0].marker}${formatNumber(params[0].value, 0)}`;
          }
        },
        grid: {
          top: '10%',
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.stateDeliveryData.map(item => item.state),
          axisTick: {
            show: false // 隐藏y轴刻度线
          },
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold',
            color: '#333'
          },
          axisLine: {
            show: false // 隐藏x轴线
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: [{
          type: 'bar',
          barWidth: '10px',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#0e792b' },
              { offset: 1, color: '#8fd3a3' }
            ]),
            borderRadius: [4, 4, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            fontSize: 12,
            fontWeight: 'bold',
            formatter: (params) => {
              return formatNumber(params.value, 0);
            }
          },
          data: this.stateDeliveryData.map(item => item.receiptQuantity)
        }]
      };
      stateDeliveryOption && this.rankingCargoChart.setOption(stateDeliveryOption, true);
    }
  }
};
</script>

<style scoped>
.kanban-title {
  padding: 15px 0;
  border-bottom: 1px solid #ccc;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
}
.search-kan .el-form-item--small.el-form-item {
  margin-bottom: 0;
}
</style>
